
(function (angular) {
    'use strict';
    
    angular.module('shared')
        .controller('addFileModal', [ "$scope", "$stateParams", "$uibModalInstance", 'coreDataService', 'folder', 'typeOptions', 'isGlobal', 'jwtService', 'supportedContentTypes', 'options', '$q',
        function ($scope, $stateParams, $uibModalInstance, coreDataService, folder, typeOptions, isGlobal, jwtService, supportedContentTypes, options, $q) {
        $scope.newFile = {};
        $scope.typeName = typeOptions.typeName;
        $scope.supportedContentTypes = supportedContentTypes;

        $scope.options = options || {};
        var optionsCount = Object.keys($scope.options).length;

        $scope.$watch('newFile.data', function(newVal, oldVal){
            if(newVal){
                if(!typeOptions.type || newVal.type.includes(typeOptions.type)){
                    optionsChecksAsync($scope.newFile.data).then(() => {
                        if(isGlobal){
                            coreDataService.uploadGlobalFile(jwtService.payload.accountId, $scope.newFile.data, folder).then(function(result){
                                $uibModalInstance.close(result);
                            }).catch(function(error){
                                
                            });
                        }
                        else{
                            coreDataService.uploadFile($stateParams.pickedApiSpaceId, $scope.newFile.data, folder).then(function(result){
                                $uibModalInstance.close(result);
                            }).catch(function(error){
                                
                            });
                        }
                    });
                }
                else{
                    $scope.wrongFileError = typeOptions.typeError;
                }
            }
        });

        function optionsChecksAsync(file){
            return $q((resolve, reject) => {
                if(optionsCount){
                    var fileReader = new FileReader();
                    fileReader.onload = (e) => {
                        var img = new Image();
                        img.onload = () => {
                            if($scope.options.minWidth && $scope.options.minWidth > img.width){
                                $scope.wrongFileError = "Width of file is to small. Should be at least: " + $scope.options.minWidth + "px";
                                return reject();
                            } if (options.minHeight && options.minHeight > img.height){
                                $scope.wrongFileError = "Height of file is to small. Should be at least: " + $scope.options.minHeight + "px";
                                return reject();
                            }
                            return resolve();
                        }
                        img.src = e.target.result;
                    }
                    fileReader.readAsDataURL(file);   
                } else {
                    return resolve();
                }
            });
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }]);

})(window.angular); 